import type { KeyBinding } from '../../../shared/CharacterTypes';
import { compileActionBindingMap } from './keyboardBindingMap';
import { isActionJustPressed } from './keyboardChordMatcher';

/** The contextual action uses interact and the established upward portal key. */
function contextualCodes(bindings: readonly KeyBinding[]) {
  const codes = compileActionBindingMap(bindings);
  const up = (codes.get('move_up') ?? []).filter(binding => binding.code === 'ArrowUp');
  codes.set('contextual_action', [...(codes.get('interact') ?? []), ...up]);
  // The copies above are the same action, not competing explicit chords.
  codes.delete('interact');
  codes.set('move_up', (codes.get('move_up') ?? []).filter(binding => binding.code !== 'ArrowUp'));
  return codes;
}

export function contextualBindingLabel(bindings: readonly KeyBinding[]): string {
  const choices = contextualCodes(bindings).get('contextual_action') ?? [];
  const names = choices.map(({ code, modifier }) => {
    const key = code === 'ArrowUp' ? '↑' : code.replace(/^Key|^Digit/, '');
    return modifier ? `${modifier.toUpperCase()}+${key}` : key;
  });
  return `[${[...new Set(names)].join(' / ') || 'Enter / Space'}]`;
}

export function matchesContextualBinding(event: KeyboardEvent, bindings: readonly KeyBinding[]): boolean {
  if (event.metaKey) return false;
  const keys = new Set([event.code]);
  if (event.shiftKey) keys.add('ShiftLeft');
  if (event.ctrlKey) keys.add('ControlLeft');
  if (event.altKey) keys.add('AltLeft');
  return isActionJustPressed(contextualCodes(bindings), 'contextual_action', new Set([event.code]), keys);
}
